import { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/nav.css";

const LOGO_URL = "https://assets.igcprintingpress.com/public%20assets/igc-mark.svg";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="nav">
      <div className="wrap nav-inner">
        <NavLink to="/" className="nav-brand" onClick={closeMenu}>
          <img
            src={LOGO_URL}
            alt="IGC Print Press"
            className="nav-logo-img"
          />
        </NavLink>

        {/* Desktop navigation */}
        <nav className="nav-links">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                "nav-link" + (isActive ? " is-active" : "")
              }
            >
              {l.label}
              <span className="nav-dot" />
            </NavLink>
          ))}
        </nav>

        <NavLink to="/quote" className="btn btn-primary nav-cta">
          Start a Print Job
        </NavLink>

        {/* Mobile hamburger */}
        <button
          type="button"
          className={`hamburger ${menuOpen ? "is-open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu ${menuOpen ? "is-open" : ""}`}>
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === "/"}
            onClick={closeMenu}
            className={({ isActive }) =>
              "mobile-link" + (isActive ? " is-active" : "")
            }
          >
            {l.label}
          </NavLink>
        ))}

        <NavLink
          to="/quote"
          className="btn btn-primary mobile-cta"
          onClick={closeMenu}
        >
          Start a Print Job
        </NavLink>
      </div>
    </header>
  );
}